import { fromBlankArray } from '@witmetrics/utils/arrays';

export const DELAYS = fromBlankArray(5, (i) => i / 10);
